module.exports = __webpack_public_path__ + "img/mediaportal_upload_complete.c65ffdef.jpg";